import type { ActiveFiler } from '@lt/components/components/HotelCard/components/FiltersPenalized';
import type { ILabel } from '@lt/components/components/Label';
import type { CurrencyType } from 'src/utils/stringUtils';

export type HotelImage = {
  webp: string;
  jpg: string;
};

export type HotelFeatures = {
  airportDistance: number | null;
  beachDistance: number | null;
  distanceToCityCenter: number | null;
  beachSurface: string | null;
  beachLine: null | 1 | 2 | 3;
  wiFi: 'FREE' | 'LOBBY_FREE' | 'LOBBY_PAID' | 'LOBBY_UNKNOWN' | 'PAID' | null;
};

// Лейблы из админки
export const ADMIN_LABEL_VARIANT_NAMES = {
  1: 'gold',
  2: 'purple',
  3: 'red',
  4: 'white',
  5: 'gray',
  6: 'redForTrustYou',
  7: 'orangeGreen',
  998: 'orange',
  999: 'checkbox',
  PLUS: 'plus',
  MINUS: 'minus',
} as const;

export const INNER_LABEL_VARIANT_NAMES = {
  INSTANT_CONFIRM: 'instantConfirm',
  NOT_TO_CONFIRM_AT_ONCE: 'notToConfirmAtOnce',
  FREE_CANCELLATION: 'freeCancellation',
} as const;

export type LabelVariantValue = {
  id: string;
  text: string;
  tooltipText?: string;
  variant: LabelVariant;
};

export type AdminLabelVariant =
  (typeof ADMIN_LABEL_VARIANT_NAMES)[keyof typeof ADMIN_LABEL_VARIANT_NAMES];

export type InnerLabelVariant =
  (typeof INNER_LABEL_VARIANT_NAMES)[keyof typeof INNER_LABEL_VARIANT_NAMES];

export type LabelVariant = AdminLabelVariant | InnerLabelVariant;

export type Availability = {
  hotel: string;
  flight: string;
};

export type AdjacentTour = {
  tourId: string;
  availability: {
    flight: string;
    hotel: string;
  };
  price: number;
  datesInfo: string;
  instantConfirm: boolean;
  href: string;
};

export type HotelCardProps = {
  id: number;
  images: HotelImage[];
  hotelPageVisited: boolean;

  bonusCount: number;
  currencyCode: CurrencyType;

  stars: number;
  hotelName: string;
  hotelLocation: string;

  rating: number;
  reviewsCount?: number;

  features: HotelFeatures;
  skiLiftDistance: number;

  instantConfirm: boolean;
  isFlexDates: boolean;
  price: number;

  innerLabels: LabelVariantValue[];
  headerLabel?: ILabel;
  isHotelOnly: boolean;

  availability: Availability;

  adjacentTours?: AdjacentTour[];

  hotelPageHref: string;
  openInCurrentTab: boolean;

  datesInfo: string;

  penalizedFilters?: ActiveFiler[];

  onLongHover?: () => void;

  className?: string;

  cashbackLabel?: string;
  cashbackIconWebp?: string;
  cashbackIconPng?: string;
  cashbackTooltipText?: string;
  labelColor: string;
  textColor: string;
};

export type MapHotelCardProps = {
  id: number;
  images: HotelImage[];
  hotelPageVisited: boolean;

  bonusCount: number;
  currencyCode: CurrencyType;
  cashbackLabel?: string;
  cashbackIconWebp?: string;
  cashbackIconPng?: string;
  cashbackTooltipText?: string;
  labelColor: string;
  textColor: string;

  stars: number;
  hotelName: string;
  hotelLocation: string;

  rating: number;
  reviewsCount?: number;

  innerLabels: LabelVariantValue[];
  headerLabel?: ILabel;
  isFreeCancellationPolicy?: boolean;
  isHotelOnly: boolean;
  isExpanded: boolean;
  availability: Availability;

  hotelPageHref: string;
  openInCurrentTab: boolean;

  features: HotelFeatures;

  skiLiftDistance: number;

  instantConfirm: boolean;
  price: number;

  onCloseIconClick: () => void;

  className?: string;
};
